const PEDEAII = "pedeaii";

export default {
  PEDEAII,
};
